export const SET_NEW_VALUE = 'SET_NEW_VALUE';
export const SET_FIELD_VALUES = 'SET_FIELD_VALUES';
export const UPDATE_VALUES = 'UPDATE_VALUES';
export const SET_NEW_ORDER = 'SET_NEW_ORDER';



// WEBPACK FOOTER //
// ./src/components/ui/MultiSelectDnD/flow/actionTypes.js